module.exports = __webpack_public_path__ + "static/pic02-d81839c30caf4ad31c1e64218f63dc14.jpg";